// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { NotificationsCommands } from '../../../../types/server/modules/notifications/commands';

export type * from '../../../../types/server/modules/notifications/commands';

export const createCommands = ( requests: Requests ): NotificationsCommands => ({
  SendUserNotification: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/notifications/:id/send-user-notification`, { id, ...query, body }, headers );
  }, { operation: 'notifications:send-user-notification', route: 'POST /notifications/:id/send-user-notification', subdomain: 'notifications', visibility: 'private' } as const ),
  MarkNotificationAsRead: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/notifications/:id/mark-notification-as-read`, { id, ...query, body }, headers );
  }, { operation: 'notifications:mark-notification-as-read', route: 'POST /notifications/:id/mark-notification-as-read', subdomain: 'notifications', visibility: 'private' } as const ),
  MarkNotificationAsUnread: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/notifications/:id/mark-notification-as-unread`, { id, ...query, body }, headers );
  }, { operation: 'notifications:mark-notification-as-unread', route: 'POST /notifications/:id/mark-notification-as-unread', subdomain: 'notifications', visibility: 'private' } as const )
});
